var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 19819"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.5 14C11.075 14 14 11.075 14 7.5C14 3.925 11.075 1 7.5 1C3.925 1 1 3.925 1 7.5C1 11.075 3.925 14 7.5 14Z",
    fill: "#B3B3B3",
    stroke: "#B3B3B3",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 19567"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.0625 9.9375L9.9375 5.0625",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.9375 9.9375L5.0625 5.0625",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon2);
export default __webpack_public_path__ + "static/media/CrossIcon2.c75d145431f6aed5e08bf4c9e0ea5623.svg";
export { ForwardRef as ReactComponent };